import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getResourceName } from '@mews-commander/legacy-entities/src/ducks/resources';
import { ApplicationState } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface ResourceNameProps {
    resourceId: string | undefined | null;
    notFoundElement?: React.ReactNode;
}

export const ResourceName: React.FC<ResourceNameProps> = ({ resourceId, notFoundElement = lt(TextKey.Unassigned) }) => {
    const enterpriseId = useCurrentEnterpriseId();

    const resourceName = useCommanderSelector((state: ApplicationState) =>
        resourceId ? getResourceName(state, { id: resourceId, enterpriseId }) : undefined
    );

    return resourceName ? <span data-test-id="resourceName">{resourceName}</span> : <>{notFoundElement}</>;
};
